<template>
  <div>
    <div class="flex justify-end mb-4 px-4">
      <SearchInput @search-select="onDealerSelected" @clear="onClearSearch" />
    </div>
    <div
      class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg text-primary-text dark:text-gray-100 dark:bg-primary-dark-bg pb-3 shadow-md">
      <div class="w-full overflow-x-auto">
        <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
          <thead class="bg-gray-100 dark:bg-gray-800 font-medium">
            <tr>
              <th class="px-2 md:px-4 py-2 md:py-4">Teslimat No</th>
              <th class="px-2 md:px-4 py-2 md:py-4">Sipariş Tarihi</th>
              <th class="px-2 md:px-4 py-2 md:py-4">Sipariş Sayısı</th>
              <th class="px-2 md:px-4 py-2 md:py-4">Bayi</th>
              <th class="px-2 md:px-4 py-2 md:py-4">Sürücü</th>
              <th class="px-2 md:px-4 py-2 md:py-4">Ürün</th>
              <th class="px-2 md:px-4 py-2 md:py-4">Miktar</th>
            <!--   <th class="px-2 md:px-4 py-2 md:py-4">Birimi</th> -->
              <th class="px-2 md:px-4 py-2 md:py-4">Plaka</th>
              <th class="px-2 md:px-4 py-2 md:py-4">Komisyon</th>
              <!-- <th class="px-2 md:px-4 py-2 md:py-4">Fiş</th> -->
              <th class="px-2 md:px-4 py-2 md:py-4">Onayla / İptal Et</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="group in groupedPendingOrders" :key="group.billId">
              <tr class="bg-blue-50 dark:bg-blue-900/20 border-b-2 border-blue-200 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900/30" 
                  @click="toggleGroup(group.billId)">
                <td class="px-2 md:px-4 py-3 font-bold text-blue-700 dark:text-blue-300">
                  {{ group.billId }}
                </td>
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  {{ group.orders[0].date && !isNaN(new Date(group.orders[0].date).getTime())
                    ? new Date(group.orders[0].date).toLocaleString("tr-TR", {
                      year: "numeric",
                      month: "numeric", 
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    : "-" }}
                </td>
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  {{ group.count }} sipariş
                </td>
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  {{ group.orders[0].dealerName }}
                </td>
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  {{ group.driverName || "-" }}
                </td>
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  {{ group.count }} farklı ürün
                </td>
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  {{ formatWeight(group.orders.reduce((sum, order) => sum + (order.deliveredTonnage || 0), 0)) }}
                </td>
                <!-- <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">TON</td> -->
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  {{ getGroupPlates(group.orders) }}
                </td>
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  {{ getGroupCommission(group.orders) }}
                </td>
                <td class="px-2 md:px-4 py-3 text-blue-700 dark:text-blue-300">
                  <div class="flex items-center justify-between">
                    <div class="inline-flex items-center justify-center gap-2">
                      <button @click.stop="openCommissionModal(group)"
                        class="relative group bg-amber-600 hover:bg-amber-700 text-white text-xs px-2 py-1 rounded">
                        <BanknotesIcon class="w-4 h-4" />
                        <span class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                          Komisyonu Düzenle
                        </span>
                      </button>
                      <button @click.stop="confirmApproveAll(group)" 
                        class="relative group bg-green-600 hover:bg-green-700 text-white text-xs px-2 py-1 rounded">
                        <CheckIcon class="w-4 h-4" />
                        <span class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                          Tümünü Onayla
                        </span>
                      </button>
                      <button @click.stop="approveGroupOrder(group)"
                        class="relative group bg-indigo-600 hover:bg-indigo-700 text-white text-xs px-2 py-1 rounded">
                        <PrinterIcon class="w-4 h-4" />
                        <span class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                          PDF Yazdır
                        </span>
                      </button>
                      <button @click.stop="confirmCancelAll(group)"
                        class="relative group bg-red-600 hover:bg-red-700 text-white text-xs px-2 py-1 rounded">
                        <XMarkIcon class="w-4 h-4" />
                        <span class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                          Tümünü İptal
                        </span>
                      </button>
                    </div>
                    <span class="ml-2">
                      <ChevronDownIcon v-if="expandedGroups[group.billId]" class="w-4 h-4" />
                      <ChevronRightIcon v-else class="w-4 h-4" />
                    </span>
                  </div>
                </td>
              </tr>
              
              <template v-if="expandedGroups[group.billId]">
                <tr v-for="order in group.orders" :key="order.id" class="border-b bg-gray-50 dark:bg-gray-800/50">
                  <td class="px-2 md:px-4 py-2 md:py-4 font-medium text-gray-600 dark:text-gray-400">
                    {{ order.orderNumber }}
                  </td>
                  <td class="px-2 md:px-4 py-2 md:py-4 text-gray-500 dark:text-gray-400">
                    
                  </td>
                  <td class="px-2 md:px-4 py-2 md:py-4 text-gray-500 dark:text-gray-400">
                    
                  </td>
                  <td class="px-2 md:px-4 py-2 md:py-4 text-gray-500 dark:text-gray-400">
                    
                  </td>
                  <td class="px-2 md:px-4 py-2 md:py-4 text-gray-500 dark:text-gray-400">
                    
                  </td>
                  <td class="px-2 md:px-4 py-2 md:py-4">
                    {{order.loadProducts.map((p) => p.urun_name).join(",")}}
                  </td>
                <td class="px-2 md:px-4 py-2 md:py-4 inline-flex items-center gap-2">
                <input type="number" v-model.number="order.deliveredTonnage" min="0" step="0.01"
                  :disabled="!order.editable"
                  class="w-24 border rounded px-2 py-1 text-sm transition-colors duration-200" :class="order.editable
                    ? 'bg-primary-bg dark:bg-gray-800'
                    : 'bg-gray-200 dark:bg-gray-700 cursor-not-allowed'
                    " />

                <div>
                  <button v-if="!order.editable" @click="order.editable = true"
                    class="relative group bg-yellow-600 hover:bg-yellow-700 text-white text-xs px-2 py-1 rounded">
                    <PencilSquareIcon class="w-5 h-5" />
                    <span
                      class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                      Düzenle
                    </span>
                  </button>
                  <button v-if="order.editable" @click="updateDelivery(order)"
                    class="relative group bg-yellow-600 hover:bg-yellow-700 text-white text-xs px-2 py-1 rounded">
                    <CheckIcon class="w-5 h-5" />
                    <span
                      class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                      Kaydet
                    </span>
                  </button>
                </div>
              </td>
            <!--   <td class="px-2 md:px-4 py-2 md:py-4">TON</td> -->
              <td class="px-2 md:px-4 py-2 md:py-4">
            
              </td>
              <!-- <td class="px-2 md:px-4 py-2 md:py-4">{{ order.commission || '-' }}</td> -->

              <!-- <td class="px-2 md:px-4 py-2 md:py-4">
                <button class="hover:underline">
                  <DocumentArrowDownIcon class="w-5 h-5 inline-block" />
                </button>
              </td> -->
              <td class="px-2 md:px-4 py-2 md:py-4 text-gray-500 dark:text-gray-400">
                
              </td>
              </tr>
              </template>
            </template>

            <tr v-if="pendingOrders.length === 0">
              <td colspan="11" class="text-center text-gray-500 pt-10">
                Henüz onay bekleyen bir teslimat bulunmamaktadır.
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="waybillHtml" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
          <div class="bg-white p-6 rounded shadow max-w-3xl w-full overflow-y-auto max-h-[80vh] relative">
            <button class="absolute top-2 right-2 text-gray-500 hover:text-primary-text dark:text-gray-100 text-lg"
              @click="waybillHtml = null">
              <XMarkIcon class="w-6 h-6 text-gray-600" />
            </button>
            <div v-html="waybillHtml" class="prose max-w-none text-black p-4" />
          </div>
        </div>
      </div>
      <AppPagination 
      :currentPage="currentPage" 
      :totalPages="totalPages" 
      @prev-page="currentPage--"
        @next-page="currentPage++" 
        @go-to-page="(page) => (currentPage = page)"
        @update:pageSize="handlePageSizeChange"
        :pageSize="pageSize"
         class="mt-6" />
    </div>
  </div>

  

  <!-- Commission Edit Modal -->
  <div v-if="showCommissionModal" @click.self="closeCommissionModal"
    class="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
    <div class="bg-primary-bg dark:bg-primary-dark-bg p-6 rounded-lg border border-light-border dark:border-dark-border w-full max-w-md relative">
      <button @click="closeCommissionModal"
        class="absolute top-2 right-2 text-gray-500 hover:text-black text-lg font-bold">
        <XMarkIcon class="w-6 h-6" />
      </button>
      <h3 class="text-lg font-semibold mb-4 text-primary-text dark:text-gray-100">Komisyonu Düzenle</h3>
      <div class="space-y-3">
        <div>
          <label class="block text-sm mb-1">Komisyon Tutarı</label>
          <input type="number" v-model.number="commissionForm.amount" step="0.01" min="0"
            class="w-full border rounded px-3 py-2 bg-primary-bg dark:bg-gray-800 dark:border-dark-border" />
        </div>
        <div>
          <label class="block text-sm mb-1">Ödeme Tipi</label>
          <select v-model="commissionForm.type" class="w-full border rounded px-3 py-2 bg-primary-bg dark:bg-gray-800 dark:border-dark-border">
            <option value="cash">Nakit</option>
            <option value="credit_cart">Kredi Kartı</option>
            <option value="loan">Veresiye</option>
            <option value="partial">Parçalı</option>
          </select>
        </div>
        <div v-if="commissionForm.type === 'partial'" class="grid grid-cols-2 gap-3">
          <div>
            <label class="block text-sm mb-1">Nakit</label>
            <input type="number" v-model.number="commissionForm.cash" step="0.01" min="0" @input="onEditCashChanged"
              class="w-full border rounded px-3 py-2 bg-primary-bg dark:bg-gray-800 dark:border-dark-border" />
          </div>
          <div>
            <label class="block text-sm mb-1">Kart</label>
            <input type="number" v-model.number="commissionForm.card" step="0.01" min="0" @input="onEditCardChanged"
              class="w-full border rounded px-3 py-2 bg-primary-bg dark:bg-gray-800 dark:border-dark-border" />
          </div>
          <div class="col-span-2 text-xs text-secondary-text">Toplam: {{ (Number(commissionForm.cash||0) + Number(commissionForm.card||0)).toFixed(2) }} / {{ Number(commissionForm.amount||0).toFixed(2) }}</div>
        </div>
        <div class="flex justify-end gap-2 pt-2">
          <button @click="closeCommissionModal" class="px-4 py-2 rounded border">İptal</button>
          <button @click="saveCommission" class="px-4 py-2 rounded bg-primary-button text-white hover:bg-primary-button-hover">Kaydet</button>
        </div>
      </div>
    </div>
  </div>

  <PrintPreviewModal v-if="showWaybillModal" :mode="printMode" :selectedOrders="[selectedWaybillOrder]"
    :driver="selectedDriver" :vehicle="selectedVehicle" :waybill="printData.waybill" @close="showWaybillModal = false"
    @cancel="resetPreviewState" @confirm-preview="finalizeApproval" />
</template>

<script>
import { getApi, deleteApi, putApi, postApi } from "@/services/api";
import AppPagination from "@/components/AppPagination.vue";
import {
  XMarkIcon,
  CheckIcon,
  BanknotesIcon,
  PencilSquareIcon,
  PrinterIcon,
  ChevronRightIcon,
  ChevronDownIcon,
} from "@heroicons/vue/24/outline";
// import { DocumentArrowDownIcon } from "@heroicons/vue/24/outline";
import PrintPreviewModal from "@/components/Modals/PrintPreviewModal.vue";
import SearchInput from "@/components/SearchInput.vue";

export default {
  name: "PendingDeliveries",
  components: {
    AppPagination,
    XMarkIcon,
    CheckIcon,
    BanknotesIcon,
    PrintPreviewModal,
    PencilSquareIcon,
    SearchInput,
    PrinterIcon,
    ChevronRightIcon,
    ChevronDownIcon,
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 50,
      pendingOrders: [],
      approvedOrders: [],
      totalOrdersCount: 0,
      isLoading: false,
      waybillHtml: null,
      selectedDealerId: null,
      orderToCancel: null,
      allDeliveries: [],
      showPrintModal: false,
      printData: {
        selectedOrders: [],
        driver: {},
        vehicle: {},
        waybill: {},
      },
      showWaybillModal: false,
      selectedWaybillOrder: null,
      selectedDriver: {},
      selectedVehicle: {},
      printMode: "waybill",
      expandedGroups: {}, 
      showCommissionModal: false,
      commissionForm: {
        deliveryId: null,
        commissionId: null,
        driverId: null,
        amount: 0,
        type: 'cash',
        cash: 0,
        card: 0,
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalOrdersCount / this.pageSize);
    },
    isFertilizerProduct() {
      if (!this.selectedWaybillOrder) return false;
      return this.selectedWaybillOrder.loadProducts?.some(product => 
        product.category_name === 'Gübre'
      );
    },
    groupedPendingOrders() {
      const groups = {};
      this.pendingOrders.forEach(order => {
        const billId = order.bill_id || 'no-bill-id';
        if (!groups[billId]) {
          groups[billId] = [];
        }
        groups[billId].push(order);
      });
      
      return Object.entries(groups).map(([billId, orders]) => ({
        driverName: (orders.find(o => o.driverName && o.driverName !== "Sürücü Yok") || orders[0])?.driverName || "-",
        billId,
        orders,
        count: orders.length
      })).sort((a, b) => a.billId.localeCompare(b.billId));
    },
  },
  methods: {
    async confirmApproveAll(group) {
      const Swal = (await import('sweetalert2')).default;
      const result = await Swal.fire({
        title: 'Seçili gruptaki tüm teslimatları onaylamak istediğinize emin misiniz?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet, tümünü onayla',
        cancelButtonText: 'Vazgeç',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'px-4 py-2 rounded bg-green-600 hover:bg-green-700 text-white',
          cancelButton: 'ml-2 px-4 py-2 rounded bg-gray-500 hover:bg-gray-600 text-white'
        },
        background: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
        color: document.documentElement.classList.contains('dark') ? '#e5e7eb' : '#111827',
      });

      if (!result.isConfirmed) return;

      const approvalTimestamp = this.getLocalApprovalTimestamp();
      await this.directApproveGroup(group, approvalTimestamp);
      this.$toast && this.$toast.success('Tüm teslimatlar onaylandı');
    },
    async confirmCancelAll(group) {
      const Swal = (await import('sweetalert2')).default;
      const result = await Swal.fire({
        title: 'Seçili gruptaki tüm teslimatları iptal etmek istediğinize emin misiniz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, tümünü iptal et',
        cancelButtonText: 'Vazgeç',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'px-4 py-2 rounded bg-red-600 hover:bg-red-700 text-white',
          cancelButton: 'ml-2 px-4 py-2 rounded bg-gray-500 hover:bg-gray-600 text-white'
        },
        background: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
        color: document.documentElement.classList.contains('dark') ? '#e5e7eb' : '#111827',
      });

      if (!result.isConfirmed) return;

      this.cancelGroupOrder(group);
    },
    async openCommissionModal(group) {
      try {
        const first = group.orders[0];
        if (!first) return;
        
        // Find the delivery that has commission data (commission is only attached to one delivery in the group)
        let deliveryWithCommission = null;
        let deliveryId = first.id;
        const firstWithDriver = group.orders.find(o => o.drivers_id) || first;
        
        // Try to find commission data from any delivery in the group
        for (const order of group.orders) {
          try {
            const delivery = await getApi(`/deliveries/${order.id}`);
            if (delivery?.commission?.commission_id) {
              deliveryWithCommission = delivery;
              deliveryId = order.id;
              break;
            }
          } catch (e) {
            // Continue to next delivery
          }
        }
        
        // If no commission found, use the first delivery
        if (!deliveryWithCommission) {
          deliveryWithCommission = await getApi(`/deliveries/${deliveryId}`);
        }
        
        const c = deliveryWithCommission?.commission || {};
        this.commissionForm = {
          deliveryId,
          commissionId: c.commission_id || null,
          driverId: c.driver_id || firstWithDriver.drivers_id || null,
          amount: Number(c.commission_amount || first.commission || 0),
          type: c.payment_type || first.paymentType || 'cash',
          cash: Number(c.cash_amount || 0),
          card: Number(c.card_amount || 0),
        };
        if (this.commissionForm.type === 'partial') {
          const total = Number(this.commissionForm.amount || 0);
          const sum = Number(this.commissionForm.cash || 0) + Number(this.commissionForm.card || 0);
          if (Math.abs(sum - total) >= 0.005) {
            const half = Number((total/2).toFixed(2));
            this.commissionForm.cash = half;
            this.commissionForm.card = Number((total - half).toFixed(2));
          }
        } else if (this.commissionForm.type === 'cash') {
          this.commissionForm.cash = this.commissionForm.amount;
          this.commissionForm.card = 0;
        } else if (this.commissionForm.type === 'credit_cart') {
          this.commissionForm.card = this.commissionForm.amount;
          this.commissionForm.cash = 0;
        } else {
          this.commissionForm.cash = 0;
          this.commissionForm.card = 0;
        }
        this.showCommissionModal = true;
      } catch (e) {
        this.$toast.error('Komisyon bilgisi alınamadı');
      }
    },
    closeCommissionModal() {
      this.showCommissionModal = false;
    },
    onEditCashChanged() {
      if (this.commissionForm.type !== 'partial') return;
      const total = Number(this.commissionForm.amount || 0);
      let cash = Number(this.commissionForm.cash || 0);
      if (isNaN(cash) || cash < 0) cash = 0;
      if (cash > total) cash = total;
      this.commissionForm.cash = cash;
      this.commissionForm.card = Number((total - cash).toFixed(2));
    },
    onEditCardChanged() {
      if (this.commissionForm.type !== 'partial') return;
      const total = Number(this.commissionForm.amount || 0);
      let card = Number(this.commissionForm.card || 0);
      if (isNaN(card) || card < 0) card = 0;
      if (card > total) card = total;
      this.commissionForm.card = card;
      this.commissionForm.cash = Number((total - card).toFixed(2));
    },
    async saveCommission() {
      try {
        const total = Number(this.commissionForm.amount || 0);
        if (total < 0 || isNaN(total)) {
          this.$toast.error('Geçerli bir komisyon giriniz');
          return;
        }
        if (this.commissionForm.type === 'partial') {
          const cash = Number(this.commissionForm.cash || 0);
          const card = Number(this.commissionForm.card || 0);
          if (cash < 0 || card < 0 || Math.abs((cash + card) - total) >= 0.005) {
            this.$toast.error('Parçalı toplamı komisyon ile eşit olmalıdır');
            return;
          }
        }
        const payload = {
          driver_id: this.commissionForm.driverId,
          commission_amount: total,
          delivery_id: this.commissionForm.deliveryId,
          payment_type: this.commissionForm.type,
          cash_amount: this.commissionForm.type === 'partial' ? Number(this.commissionForm.cash || 0) : (this.commissionForm.type === 'cash' ? total : 0),
          card_amount: this.commissionForm.type === 'partial' ? Number(this.commissionForm.card || 0) : (this.commissionForm.type === 'credit_cart' ? total : 0),
        };
        if (this.commissionForm.commissionId) {
          await putApi(`/commissions/${this.commissionForm.commissionId}`, payload);
        } else {
          await postApi(`/deliveries/${this.commissionForm.deliveryId}/commission`, payload);
        }
        this.$toast.success('Komisyon güncellendi');
        this.showCommissionModal = false;
        await this.fetchAllDeliveries();
      } catch (e) {
        this.$toast.error('Komisyon güncellenemedi');
      }
    },
    toggleGroup(billId) {
      this.expandedGroups[billId] = !this.expandedGroups[billId];
    },

    getGroupPlates(orders) {
      const plates = orders
        .map(order => order.vehiclePlate || order.delivery_plate || "-")
        .filter(plate => plate && plate !== "-")
        .filter((plate, index, arr) => arr.indexOf(plate) === index); 
      
      if (plates.length === 0) return "-";
      if (plates.length === 1) return plates[0];
      return plates.join(", ");
    },

    getGroupCommission(orders) {
      // Find commission from any order in the group
      const orderWithCommission = orders.find(order => 
        order.commission && order.commission !== "-" && order.commission !== 0
      );
      
      if (orderWithCommission) {
        return this.formatNumber(orderWithCommission.commission);
      }
      
      return "-";
    },

async directApproveGroup(group, approvalTime = null) {
  try {
    const approvalTimestamp = approvalTime || this.getLocalApprovalTimestamp();
    const sameBillIdOrders = group.orders;

    for (const groupOrder of sameBillIdOrders) {
      await this.directApprove(groupOrder, approvalTimestamp);
    }

    this.$toast.success(`Sipariş onaylandı.`);
    this.fetchAllDeliveries();
  } catch (error) {
    this.$toast.error("Grup onaylama sırasında hata oluştu.");
  }
},

    approveGroupOrder(group) {
      const firstOrder = group.orders[0];
      const driverSource = group.orders.find(o => o.driverName && o.driverName !== "Sürücü Yok") || firstOrder;
      this.selectedWaybillOrder = firstOrder;
      
      this.selectedDriver = {
        name: driverSource.driverName,
        driver_name: driverSource.driverName,
        driver_telno: driverSource.drivers_tel,
        driver_tcno: driverSource.driver_tcno,
        driver_licenceno: driverSource.driver_licenceno,
        address: driverSource.driver_address,
      };

      const allPlates = group.orders
        .map(order => order.vehiclePlate)
        .filter(plate => plate && plate !== "-")
        .filter((plate, index, arr) => arr.indexOf(plate) === index); 
      
      const allTrailers = group.orders
        .map(order => order.vehicleTrailer)
        .filter(trailer => trailer && trailer !== "-")
        .filter((trailer, index, arr) => arr.indexOf(trailer) === index);

      this.selectedVehicle = {
        plate: allPlates.length > 0 ? allPlates.join(", ") : "-",
        trailer: allTrailers.length > 0 ? allTrailers.join(", ") : "-",
      };

      const items = group.orders.map((order, index) => ({
        id: index + 1,
        customer: order.dealerName,
        destination: order.delivery_shipment_address || "Adres Yok",
        type: order.loadProducts.map((p) => p.urun_name).join(", ") || "Ürün Yok",
        quantity: order.deliveredTonnage || 0,
        price: order.unit_price || 0,
      }));

      this.printData.waybill = {
        no: `${group.billId}`,
        bill_id: group.billId,
        date: new Date().toLocaleDateString("tr-TR"),
        sender: "",
        loadingLocation: "",
        deliveryMethod: firstOrder.deliveryMethod || 'fot',
        items: items,
      };

      this.printMode = "waybill";
      this.showWaybillModal = true;
    },

    cancelGroupOrder(group) {
      this.orderToCancel = group;
      this.confirmCancel();
    },

    formatNumber(value) {
  if (value === null || value === undefined || value === '') return '';
  return Number(value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
},

    formatWeight(value) {
      if (value === null || value === undefined || value === '') return '';
      const num = Number(value);
      if (num >= 1000) {
        return num.toLocaleString('tr-TR');
      } else {
        return num.toString();
      }
    },



    async fetchOrderNumbers(orderIds) {
      const uniqueIds = [...new Set(orderIds)];
      const orderMap = {};

      const promises = uniqueIds.map((id) =>
        getApi(`/orders/id/${id}`)
          .then((res) => {
            orderMap[id] = res.order_number || `#${id}`;
          })
          .catch(() => {
            orderMap[id] = `${id}`;
          })
      );

      await Promise.all(promises);
      return orderMap;
    },


    getLocalApprovalTimestamp() {
      const now = new Date();
      const pad = (num, size = 2) => String(num).padStart(size, "0");
      const offsetMinutes = -now.getTimezoneOffset();
      const sign = offsetMinutes >= 0 ? "+" : "-";
      const absOffset = Math.abs(offsetMinutes);
      const offsetHours = pad(Math.floor(absOffset / 60));
      const offsetMins = pad(absOffset % 60);

      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}.${pad(now.getMilliseconds(), 3)}${sign}${offsetHours}:${offsetMins}`;
    },

    async directApprove(order, approvalTime = null) {
      try {
        const sameBillIdOrders = this.pendingOrders.filter((pendingOrder) => 
          pendingOrder.bill_id && pendingOrder.bill_id === order.bill_id
        );
        const ordersToApprove = sameBillIdOrders.length ? sameBillIdOrders : [order];
        const deliveryTime = approvalTime || this.getLocalApprovalTimestamp();

        for (const groupOrder of ordersToApprove) {
          await putApi(`/deliveries/${groupOrder.id}`, {
            dealer_id: groupOrder.dealer_id,
            product_id: groupOrder.product_id,
            order_id: groupOrder.order_id,
            delivery_tonnage: groupOrder.deliveredTonnage,
            drivers_id: String(groupOrder.drivers_id),
            drivers_tel: groupOrder.drivers_tel || "",
            delivery_plate: groupOrder.vehiclePlate || groupOrder.delivery_plate || "",
            delivery_trailer: groupOrder.vehicleTrailer || "",
            delivery_time: deliveryTime,
            delivery_shipment_address: groupOrder.delivery_shipment_address || "",
            waybill: groupOrder.waybill || "",
            bill_id: groupOrder.bill_id || "",
            is_approved: 1,
            delivery_method: groupOrder.deliveryMethod || 'fot',
          });
        }

        this.fetchAllDeliveries();
      } catch (error) {
        this.$toast.error("Direkt onay sırasında hata oluştu.");
      }
    },

    approveOrder(order) {
      this.selectedWaybillOrder = order;

      this.selectedDriver = {
        name: order.driverName,
        driver_name: order.driverName,
        driver_telno: order.drivers_tel,
        driver_tcno: order.driver_tcno,
        driver_licenceno: order.driver_licenceno,
        address: order.driver_address,
      };

      this.selectedVehicle = {
        plate: order.vehiclePlate || "-",
        trailer: order.vehicleTrailer || "-",
      };

      this.printData.waybill = {
        no: `${order.orderNumber}`,
        bill_id: order.bill_id || order.orderNumber,
        date: new Date().toLocaleDateString("tr-TR"),
        sender: "",
        loadingLocation: "",
        deliveryMethod: order.deliveryMethod || 'fot',
        items: [
          {
            id: 1,
            customer: order.dealerName,
            destination: order.delivery_shipment_address || "Adres Yok",
            type:
              order.loadProducts.map((p) => p.urun_name).join(", ") ||
              "Ürün Yok",
            quantity: order.deliveredTonnage || 0,
            price: order.unit_price || 0,
          },
        ],
      };

      this.printMode = "waybill";
      this.showWaybillModal = true;
    },

    resetPreviewState() {
      this.showWaybillModal = null;
    },

    async finalizeApproval() {
      if (!this.selectedWaybillOrder) return;
      const order = this.selectedWaybillOrder;
      this.showWaybillModal = false;
      if (!order) return;

      try {
        const approvalTimestamp = this.getLocalApprovalTimestamp();
        // Find the group that contains this order
        const group = this.groupedPendingOrders.find(g => 
          g.orders.some(o => o.id === order.id)
        );

        if (group) {
          // Use the same logic as "approve all" button
          await this.directApproveGroup(group, approvalTimestamp);
          this.$toast.success('Tüm teslimatlar onaylandı');
        } else {
          // Fallback for single orders
          await this.directApprove(order, approvalTimestamp);
          this.$toast.success(`Sipariş ${order.orderNumber} onaylandı.`);
        }
        
        this.fetchAllDeliveries();
      } catch (error) {
        this.$toast.error("Onay sırasında hata oluştu.");
      } finally {
        this.selectedWaybillOrder = null;
      }
    },


    cancelOrder(order) {
      this.orderToCancel = order;
      this.showConfirmModal = true;
    },

    async confirmCancel() {
      try {
        if (this.orderToCancel.orders) {
          for (const order of this.orderToCancel.orders) {
            const deliveryId = order.latestDeliveryId;
            if (deliveryId) {
              await deleteApi(`/deliveries/${deliveryId}`);
            }
          }
          this.$toast.success(`Teslimatlar iptal edildi.`);
        } else {
          const deliveryId = this.orderToCancel.latestDeliveryId;
          if (!deliveryId) {
            this.$toast.error("Teslimat ID bulunamadı!");
            return;
          }

          const deletedDelivery = await deleteApi(`/deliveries/${deliveryId}`);
          this.$toast.success("Teslimat iptal edildi ve kalan miktara eklendi.");

          const orderIndex = this.pendingOrders.findIndex(
            (o) => o.id === deletedDelivery.order_id
          );

          if (orderIndex !== -1) {
            const existingOrder = this.pendingOrders[orderIndex];

            const updatedDelivered =
              existingOrder.deliveredTonnage - deletedDelivery.delivery_tonnage;
            const updatedRemaining =
              existingOrder.remainingTonnage + deletedDelivery.delivery_tonnage;

            const updatedOrder = {
              ...existingOrder,
              deliveredTonnage: Math.max(updatedDelivered, 0),
              remainingTonnage: updatedRemaining,
              latestDeliveryId: null,
            };

            if (updatedOrder.deliveredTonnage <= 0) {
              this.pendingOrders.splice(orderIndex, 1);
            } else {
              this.pendingOrders.splice(orderIndex, 1, updatedOrder);
            }
          }
        }
      } catch (error) {
        this.$toast.error("Teslimat iptali sırasında hata oluştu.");
      } finally {
        this.orderToCancel = null;

        await this.fetchAllDeliveries();
      }
    },

    async fetchDriversInfo(driverIds) {
      if (!driverIds || driverIds.length === 0) return {};

      try {
        const uniqueDriverIds = [...new Set(
          driverIds
            .map((id) => Number(id))
            .filter((id) => Number.isInteger(id) && id > 0)
        )];

        if (uniqueDriverIds.length === 0) return {};

        const driverPromises = uniqueDriverIds.map((id) =>
          getApi(`/drivers/${id}`).catch(() => null)
        );

        const driversData = await Promise.all(driverPromises);

        const driversMap = {};
        driversData.forEach((driver, index) => {
          if (driver) {
            driversMap[uniqueDriverIds[index]] = driver;
          }
        });

        return driversMap;
      } catch (error) {
        return {};
      }
    },

    async fetchProductsInfo(productIds) {
      const map = {};
      const promises = productIds.map((id) =>
        getApi(`/products/${id}`)
          .then((res) => {
            map[id] = res.name || "Ürün";
          })
          .catch(() => { })
      );
      await Promise.all(promises);
      return map;
    },

    async fetchDealersInfo(dealerIds) {
      const map = {};
      const promises = dealerIds.map((id) =>
        getApi(`/dealers/${id}`)
          .then((res) => {
            map[id] = res;
          })
          .catch(() => { })
      );
      await Promise.all(promises);
      return map;
    },

    async fetchAllDeliveries() {
      this.isLoading = true;
      try {
        const take = this.pageSize;
        const skip = (this.currentPage - 1) * take;

        let response;

        if (this.selectedDealerId) {
          const dealer = this.selectedDealerId;
          const status = 0;
          response = await getApi(`/deliveries/by_dealer/${dealer}/${status}/${take}/${skip}`);
        } else {
          response = await getApi(`/deliveries/unapproved/${take}/${skip}`);
        }

        const deliveries = response?.deliveries || [];
        this.totalOrdersCount = response?.total_result || 0;
        const driverIds = deliveries.map((d) => d.drivers_id);
        const driversMap = await this.fetchDriversInfo(driverIds);

        const orderIds = deliveries.map((d) => d.order_id);
        const orderNumberMap = await this.fetchOrderNumbers(orderIds);

        this.pendingOrders = deliveries.map((delivery) => {
          const product = delivery.product || {};
          const dealer = delivery.dealer || {};
          const normalizedDriverId = Number(delivery.drivers_id);
          const fallbackDriver = Number.isInteger(normalizedDriverId) ? (driversMap[normalizedDriverId] || {}) : {};
          const driver = delivery.commission?.driver || fallbackDriver || {};
          const stockUnit = product.stock?.unit || {};


          return {
            id: delivery.delivery_id,
            orderNumber: orderNumberMap[delivery.order_id] || `#${delivery.order_id}`,
            date: delivery.delivery_time
              ? new Date(delivery.delivery_time)
              : null,
            driverName: driver.driver_name || "Sürücü Yok",
            driver_tcno: driver.driver_tcno || "",
            driver_licenceno: driver.driver_licenceno || "",
            driver_address: driver.driver_address || "",
            loadProducts: [{ 
              urun_name: product.name || "Ürün Yok",
              category_name: product.category?.category_name || "Kategori Yok"
            }],
            totalTonnage: delivery.delivery_tonnage || 0,
            deliveredTonnage: delivery.delivery_tonnage || 0,
            remainingTonnage: 0,
            dealerName: dealer.dealer_name || "Bayi Yok",
            vehiclePlate: delivery.delivery_plate || "-",
            latestDeliveryId: delivery.delivery_id,
            commission: delivery.commission?.commission_amount || "-",
            paymentType: delivery.commission?.payment_type || 'cash',
            unitName: stockUnit.name || "Birim Yok",
            isApproved: delivery.is_approved === 0,
            dealer_id: delivery.dealer_id || null,
            product_id: delivery.product_id || null,
            drivers_id: delivery.drivers_id || null,
            drivers_tel: delivery.drivers_tel || null,
            order_id: delivery.order_id || null,
            delivery_shipment_address:
              delivery.delivery_shipment_address || "-",
            vehicleTrailer: delivery.delivery_trailer || "-",
            waybill: delivery.waybill || "",
            bill_id: delivery.bill_id || "",
            editable: false,
            deliveryMethod: delivery.delivery_method || 'fot',
          };
        });
        this.approvedOrders = [];
      } catch (error) {
        this.pendingOrders = [];
        this.totalOrdersCount = 0;
        this.$toast.error("Teslimatlar alınırken hata oluştu!");
      } finally {
        this.isLoading = false;
      }
    },

    async onDealerSelected(dealer) {
      this.selectedDealerId = dealer.dealer_id;
      this.currentPage = 1;
      await this.fetchAllDeliveries();
    },

    onClearSearch() {
      this.selectedDealerId = null;
      this.currentPage = 1;
      this.fetchAllDeliveries();
    },

    handlePageSizeChange(newPageSize) {
      this.pageSize = newPageSize;
      this.currentPage = 1;
      this.fetchAllDeliveries();
    },

async updateDelivery(order) {
  try {
    const newTonnage = Number(order.deliveredTonnage);

    if (!newTonnage || newTonnage <= 0) {
      this.$toast.error("Geçerli bir miktar giriniz.");
      return;
    }

    const orderDeliveriesRes = await getApi(`/deliveries/order/${order.order_id}/all`);
    const allDeliveries = orderDeliveriesRes?.deliveries || [];

    const orderDetail = await getApi(`/orders/id/${order.order_id}`);
    const totalOrderTonnage = orderDetail?.order_tonnage || 0;

    const currentDelivery = allDeliveries.find(
      (d) => d.delivery_id === order.id
    );
    const currentTonnage = Number(currentDelivery?.delivery_tonnage || 0);

    if (currentTonnage === newTonnage) {
      this.$toast.info(
        "Teslimat miktarı zaten bu değerdi. Değişiklik yapılmadı."
      );
      order.editable = false;
      return;
    }

    const otherTotal = allDeliveries
      .filter(
        (d) => String(d.order_id) === String(order.order_id) &&
          String(d.delivery_id) !== String(order.id)
      )
      .reduce((sum, d) => sum + Number(d.delivery_tonnage || 0), 0);

    const totalAfterUpdate = otherTotal + newTonnage;

    if (totalAfterUpdate > totalOrderTonnage) {
      this.$toast.error(`Teslimat miktarı toplam sipariş miktarını aşamaz.`);
      return;
    }

    await putApi(`/deliveries/${order.id}`, {
      dealer_id: order.dealer_id,
      product_id: order.product_id,
      order_id: order.order_id,
      delivery_tonnage: newTonnage,
      drivers_id: String(order.drivers_id),
      drivers_tel: order.drivers_tel || "",
      delivery_plate: order.vehiclePlate || order.delivery_plate || "",
      delivery_trailer: order.vehicleTrailer || "",
      delivery_time: order.date,
      delivery_shipment_address: order.delivery_shipment_address || "",
      waybill: order.waybill || "",
      bill_id: order.bill_id || "",
      is_approved: 0,
    });

    order.remainingTonnage = Math.max(
      totalOrderTonnage - totalAfterUpdate,
      0
    );
    order.editable = false;

    this.$toast.success("Teslimat miktarı başarıyla güncellendi.");
  } catch (error) {
    this.$toast.error("Teslimat güncellenirken hata oluştu.");
    console.error(error);
  }
},
  },
  watch: {
    currentPage() {
      this.fetchAllDeliveries();
    },
    pageSize() {
      this.currentPage = 1;
      this.fetchAllDeliveries();
    }
  },
  mounted() {
    this.fetchAllDeliveries();
  },
};
</script>
